<template>
  <div>
    <el-row style="margin-bottom: 24px;border-bottom: 1px solid #ddd;">
      <el-col :span="16" style="vertical-align: middle;">
        <h1>{{metadata['title']}}</h1>
      </el-col>
      <el-col :span="8" style="text-align: right;vertical-align: middle;">
        <el-button v-show="active_tab_name === 'metadata'" icon="el-icon-edit" @click="handle_save_button_click">儲存變更</el-button>
      </el-col>
    </el-row>
    <el-tabs v-model="active_tab_name" type="card">
      <el-tab-pane label="詮釋資料管理" name="metadata">
        <EditViewForm 
          :handle_dynamic_form_update="handle_dynamic_form_update"
          :handle_file_upload="handle_file_upload"
          :page_structure="page_structure"
          :preloaded_data="metadata"
          :mode="mode"
          :preloaded_rules="rules"
          @update-valid="(valid)=>{form_valid = valid}"
        />
      </el-tab-pane>
      <el-tab-pane label="數位物件管理" name="digital_object" v-if="this.article_id">
        <EditPageDigitalObjectTab 
          :article_type="article_type"
          :article_id="article_id"
        />
      </el-tab-pane>
    </el-tabs>
    <LoadingBlock :active="loading"></LoadingBlock>
  </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import LoadingBlock from '@/components/backstage/LoadingBlock/LoadingBlock.vue'
import PageStructure from '@/views/backstage/structure/detail_page/EditPageStructure'
import EditPageDigitalObjectTab from '@/views/backstage/pages/EditPageDigitalObjectTab'
import EditViewForm from '@/components/backstage/EditViewForm/EditViewForm.vue'
import breadcrumbMixin from '@/mixins/breadcrumbMixin'

export default {
    mixins: [breadcrumbMixin],
    components: {
      LoadingBlock,
      EditPageDigitalObjectTab,
      EditViewForm
    },
    data() {
      return {
        loading: false,//TODO: change this to true
        active_tab_name: 'metadata',
        page_structure: [],
        metadata: {}, 
        resource_api: process.env.VUE_APP_API_BACKSTAGE_URL + '/article',
        resource_identifier: 'system_id',
        article_id: null,
        article_type: null,
        options: {},
        file_lists: {},
        file: {},
        rules: {},
        preloaded_fields: ['fk_recordgroup_id', 'fk_sub_recordgroup_id', 'fk_series_id', 'fk_folder_id'],

        container: '',
        form_valid: true,
      }
    },
    computed: {
      mode () {
        return this.article_id? 'edit': 'add'
      }
    },
    watch: {
      '$route.params.id': function (id) {
        this.article_id = id
      }
    },
    created: function () {
      this.init()
    },
    methods: {
      init() {
        this.permission_check({
          resource_info: { name: this.permission.RESOURCE_DIGITAL_RESOURCE_MANAGEMENT },
          access: { name: this.permission.EDIT },
          reject: { action: this.permission.REJECT_REDIRECT, path: '/dashboard' }
        })

        console.log('EditPage: route params:', this.$route.params)
        console.log('EditPage: route type:', this.$route.params.type)
        console.log('EditPage: route mode:', this.$route.params.mode)
        console.log('EditPage: route id:', this.$route.params.id)
        console.log('EditPage: route query:', this.$route.query)

        if (!this.$route.params.type) {
          //TODO: parameterize this, or use state machine to control
          this.backstage_router_push({ path: `/digital-resource-management` })
          return 
        }

        this.page_structure = PageStructure(this.$route.params.type)
        console.log('EditPage: page structure:', this.page_structure)

        this.article_id = this.$route.params.id
        console.log('EditPage: article id:', this.article_id)

        this.article_type = this.$route.params.type
        console.log('EditPage: article type:', this.article_type)

        if (this.$route.query['metadata'] ) {
          let clone = Object.assign({}, this.$route.query['metadata'])
          clone[this.resource_identifier] = null
          this.metadata = clone
          this.update_breadcrumbs_title(this.metadata['title'])
        } 
        else {
          if ((!this.$route.query || !this.$route.query['control_level'] || !this.$route.query['control_level']['recordgroup']) && 
              !this.$route.params.id
          ) {
            //TODO: parameterize this, or use state machine to control
            this.backstage_router_push({ path: `/digital-resource-management` })
            return 
          }

          let metadata_temp = {}

          if (this.$route.query &&  this.$route.query['control_level'] && this.$route.query['control_level']['recordgroup']) {
            //TODO: user unified resource desciptor to get their info
            metadata_temp['fk_recordgroup_id'] = this.$route.query['control_level']['recordgroup']['id']
            metadata_temp['fk_sub_recordgroup_id'] = this.$route.query['control_level']['sub_recordgroup']['id']
            metadata_temp['fk_series_id'] = this.$route.query['control_level']['series']['id']
            metadata_temp['fk_folder_id'] = this.$route.query['control_level']['folder']['id']

            metadata_temp['recordgroup_name'] = this.$route.query['control_level']['recordgroup']['name']
            metadata_temp['sub_recordgroup_name'] = this.$route.query['control_level']['sub_recordgroup']['name']
            metadata_temp['series_name'] = this.$route.query['control_level']['series']['name']
            metadata_temp['folder_name'] = this.$route.query['control_level']['folder']['name']

            metadata_temp['recordgroup_number'] = this.$route.query['control_level']['recordgroup']['number']
            metadata_temp['sub_recordgroup_number'] = this.$route.query['control_level']['sub_recordgroup']['number']
            metadata_temp['series_number'] = this.$route.query['control_level']['series']['number']
            metadata_temp['folder_number'] = this.$route.query['control_level']['folder']['number']

            metadata_temp['recordgroup_keywords'] = this.$route.query['control_level']['recordgroup']['keywords']
            metadata_temp['sub_recordgroup_keywords'] = this.$route.query['control_level']['sub_recordgroup']['keywords']
            metadata_temp['series_keywords'] = this.$route.query['control_level']['series']['keywords']
            metadata_temp['folder_keywords'] = this.$route.query['control_level']['folder']['keywords']

            metadata_temp['recordgroup_abstract'] = this.$route.query['control_level']['recordgroup']['abstract']
            metadata_temp['sub_recordgroup_abstract'] = this.$route.query['control_level']['sub_recordgroup']['abstract']
            metadata_temp['series_abstract'] = this.$route.query['control_level']['series']['abstract']
            metadata_temp['folder_name_abstract'] = this.$route.query['control_level']['folder']['abstract']

            metadata_temp = this.translate_to_edit_data(this.page_structure, metadata_temp, {mode: 'add'})
          }

          this.metadata = this.forge_context_container(this.page_structure, metadata_temp)
        
          console.log('EditPage: metadata', this.metadata)

          this.get_metadata()
        }

        this.rules = this.retrieve_validation_rule(this.page_structure)
      },
      handle_save_button_click () {
        console.log('save button clicked')

        if (!this.metadata['fk_recordgroup_id'] || !this.metadata['fk_series_id'] || !this.metadata['fk_sub_recordgroup_id']) {
          console.log('err: no fk_recordgroup_id / fk_sub_recordgroup_id / fk_series_id')
          return
        }

        if (!this.form_valid) {
          this.notify_message(this.ERROR.LEVEL.ERROR, '新增/編輯失敗', '表格不符格式')
          return
        }

        console.log('this.file_lists:', this.file_lists)

        let param = this.translate_to_form_data(this.page_structure, this.metadata)

        for (let id of this.preloaded_fields) {
          if(typeof this.metadata[id] !== 'undefined' && this.metadata[id] !== null && this.metadata[id] !== '' ) {
            param.append(id, this.metadata[id]);
          }
        }

        let config = { headers:{'Content-Type':'multipart/form-data'} } 

        let action = 'add'
        if (this.article_id) {
           action = 'edit'
           param.append(this.resource_identifier, this.article_id);
        }
        axios.post(this.resource_api+'/'+action, param, config)
          .then (response => { 
            if (!response.data.success) {
              console.log('save/edit failed, msg='+response.data.message+', reponse=', response)
              this.notify_message(this.ERROR.LEVEL.ERROR, '新增/編輯失敗', response.data.message)
              return
            }

            console.log('save/edit succeed, response=', response)
            this.notify_message(this.ERROR.LEVEL.SUCCESS, '新增/編輯成功!', '')
            this.backstage_router_push({ path: `/digital-resource-management/${this.article_type}/view/${response.data.payload.system_id}` })
          }) 
          .catch(({err}) => { 
            console.log('save/edit failed, err=', err)
            this.notify_message(this.ERROR.LEVEL.ERROR, '新增/編輯失敗', this.ERROR.MSG.general_err_msg)
          }) 
      },
      handle_delete_button_click () {
        console.log('delete button clicked')
      },
      get_metadata () {
        if (!this.article_id) {
          return
        }

        this.loading = true
        
        axios.get(this.resource_api+'/get', {params: {system_id:this.article_id}})
            .then((response) => {
              this.loading = false
              console.log('reponse: ', response.data.payload)
              if (response.data.success) {
                this.$set(this, 'metadata', this.translate_to_edit_data(this.page_structure, response.data.payload, {mode: 'edit'}))
                this.update_breadcrumbs_title(this.metadata['title'])
              }
              else {
                  this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得資料', response.data.message)
              }
            })
            .catch(err => {
                this.loading = false
                console.log(err)
                this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得資料', this.ERROR.MSG.general_err_msg)
            })
      },
      handle_file_upload (file_list_name, file) {
        console.log('handle file upload: file=',file_list_name, file)
        this.file_lists[file_list_name] = file
      },
      handle_dynamic_form_update (key, form_value) {
        console.log('EditPage: handle_dynamic_form_update:' + key + ', value:', form_value)

        this.$set(this.metadata, key, form_value)
      }
    }
  };
</script>

<style lang="scss" scoped>

.action_buttons {
  float: right;
  .el-button {
    margin-right: 22px;
  }
}

.choices-radio{
  margin-bottom: 22px;
}

.clearfix::after {
    content: "";
    clear: both;
    display: table;
}

.field {
  width: 300px;
}
</style>
